import { useSelector } from "react-redux";

import type { ArticleEntity } from "@similarweb/pro-education-bar";

export const parsedArticle = <T extends ArticleEntity & { draft?: boolean; body?: string; html_url?: string }>(
    response: T,
) => {
    return {
        active: response.draft,
        content: response.body,
        docType: 1,
        id: response.id,
        link: response.html_url,
        title: response.title,
        attachments: [],
    };
};

export const useCurrentPageState = (): string | undefined => {
    return useSelector((state) => {
        const { routing } = state;
        return routing.stateConfig?.stateNameForEductionBar || routing.currentPage;
    });
};

export const getEducationData = (currentPage?: string): EducationData | undefined => {
    if (!currentPage) {
        return undefined;
    }

    return window.education?.[currentPage];
};

export const useGetEducationDataForPage = (): EducationData | undefined => {
    return getEducationData(useCurrentPageState());
};
